const config = {
  url_home: "/",
  url_graph: "http://localhost:3000/graph/15/",
  categories: {
    currency_pairs_1: [
      "EURUSD",
      "XAUUSD",
      "GBPUSD",
      "USDJPY",
      "USDCHF",
      "AUDUSD",
      "NZDUSD",
      "USDCAD",
      "NZDCAD",
      "EURJPY",
      "GBPJPY",
      "GBPAUD",
      "NZDJPY",
      "GBPCAD",
      "AUDJPY",
      "CHFJPY",
      "GBPCHF",
      "EURAUD",
      "EURCHF",
      "EURCAD",
      "EURGBP",
      "AUDCAD",
      "CADJPY",
      "GBPNZD",
      "AUDNZD",
      "AUDCHF",
      "EURNZD",
      "NZDCHF",
      "CADCHF",
      "USDSEK",
      "EURSEK",
      "EURNOK",
      "USDNOK",
      "USDMXN",
      "USDZAR",
      "USDHKD",
      "ZARJPY",
      "XAGUSD",
      "EURILS",
      "GBPSEK",
      "EURCHF",
      "ADAUSD",
    ],
    currency_pairs_2: [
      "USDNPR",
      "USDNZD",
      "USDOMR",
      "USDPEN",
      "USDPGK",
      "USDPHP",
      "USDPKR",
      "USDPYG",
      "USDQAR",
      "USDRON",
      "USDRSD",
      "USDSAR",
      "USDSCR",
      "USDSLL",
      "USDTHB",
      "USDTND",
      "USDTTD",
      "USDTWD",
      "USDTZS",
      "USDUAH",
      "USDUGX",
      "USDUYU",
      "USDUZS",
      "USDVND",
      "USDXOF",
      "USDYER",
      "USDAFN",
      "USDALL",
      "USDAMD",
      "USDAOA",
      "USDAWG",
      "USDAZN",
      "USDBAM",
      "USDBBD",
      "USDBIF",
      "USDBMD",
      "USDBSD",
      "USDBZD",
      "USDCDF",
      "USDCUP",
      "USDCVE",
      "USDDJF",
      "USDETB",
      "USDGEL",
      "USDGHS",
      "USDGIP",
      "USDGMD",
      "USDGNF",
      "USDGTQ",
      "USDGYD",
      "USDHTG",
      "USDIQD",
      "USDIRR",
      "USDISK",
      "USDKGS",
      "USDKHR",
      "USDKMF",
      "USDLAK",
      "USDLRD",
      "USDLSL",
      "USDLYD",
      "USDMMK",
      "USDMOP",
      "USDMWK",
      "USDMZN",
      "USDPAB",
      "USDRWF",
      "USDSBD",
      "USDSDG",
      "USDSOS",
      "USDSRD",
      "USDSVC",
      "USDSZL",
      "USDTJS",
      "USDTMT",
      "USDTOP",
      "USDXAF",
      "USDXCD",
      "USDZMW",
      "TRYJPY",
      "USDCNH",
      "GBPHUF",
      "USDINR-e",
      "XRPUSD",
      "USDCNY",
      "USDSGD",
      "USDHUF",
      "USDDKK",
      "EURPLN",
      "USDTRY",
      "EURZAR",
      "USDPLN",
      "EURTRY",
      "USDRUB",
      "EURHUF",
      "CHFHUF",
      "EURRUB",
      "GBPSGD",
      "EURDKK",
      "GBPILS",
      "USDILS",
      "USDINR",
      "USDCLP",
      "EOSUSD",
      "USDAED",
      "USDANG",
      "USDARS",
      "USDAUD",
      "USDBDT",
      "USDBGN",
      "USDBHD",
      "USDBND",
      "USDBOB",
      "USDBRL",
      "USDBWP",
      "USDCOP",
      "USDCRC",
      "USDCZK",
      "USDDOP",
      "USDDZD",
      "USDEGP",
      "USDEUR",
      "USDFJD",
      "USDGBP",
      "USDHNL",
      "USDHRK",
      "USDIDR",
      "USDJMD",
      "USDJOD",
      "USDKES",
      "USDKRW",
      "USDKWD",
      "USDKYD",
      "USDKZT",
      "USDLBP",
      "USDLKR",
      "USDMAD",
      "USDMDL",
      "USDMKD",
      "USDMUR",
      "USDMVR",
      "USDMYR",
      "USDNAD",
      "USDNGN",
      "XAGUSD",
    ],
    stocks: [
      "#EEM",
      "#GS",
      "SOYF",
      "#BOA",
      "#BOEING",
      "#MASTERCARD",
      "#PFIZER",
      "#NETFLIX",
      "#WAL_MART",
      "#XLE",
      "#CHEVRON",
      "#EWZ",
      "#GROUPON",
      "#VISA",
      "#SNAPCHAT",
      "#BERKSHIRE",
      "#AMERICAN_E",
      "#EXXONMOBIL",
      "#DISNEY",
      "#PG",
      "#JNJ",
      "#TEVA",
      "#CAT",
      "#GOOGLE",
      "#FACEBOOK",
      "#APPLE",
      "#MICROSOFT",
      "#INTEL",
      "#AMAZON",
      "#CISCO",
      "#CITIGROUP",
      "#COCA-COLA",
      "#JP_MORGAN",
      "#MCDONALDS",
      "#GE",
      "#GM",
      "#TESLA",
      "#AT&T",
      "#TWITTER",
      "#ALIBABA",
      "BARC.uk",
      "BA.us",
      "PFE.us",
      "MSFT.us",
      "FAANG",
      "UBER.us",
      "DIS.us",
      "F.us",
      "FB.us",
      "INTC.us",
      "GOOG.us",
      "NFLX.us",
      "BAC.us",
      "#AT&T",
      "#SNAPCHAT",
      "#XLE",
      "#CHEVRON",
      "#EXXONMOBIL",
      "#TWITTER",
      "#TESLA",
      "#EWZ",
      "AMZN.us",
      "ZM.us",
      "NVDA.us",
      "BYND.us",
      "#EEM",
      "XOM.us",
      "#GROUPON",
      "#BOEING",
      "#ALIBABA",
      "TSLA.us",
      "BABA.us",
      "#PG",
      "JD.us",
      "#CAT",
      "#JNJ",
      "#GOOGLE",
      "#GE",
      "#DISNEY",
      "#CITIGROUP",
      "#PFIZER",
      "#APPLE",
      "META",
      "#GM",
      "#TEVA",
      "#BOA",
      "#AMAZON",
      "#GS",
      "#BERKSHIRE",
      "#VISA",
      "#MASTERCARD",
      "#NETFLIX",
      "#INTEL",
      "#MICROSOFT",
      "#WAL_MART",
      "AAPL.us",
      "#GDX",
      "#CISCO",
      "#COCA-COLA",
      "#MCDONALDS",
      "#JP_MORGAN",
      "JPM.us",
      "#AMERICAN_E",
      "T.us",
      "VOLX",
      "#GDX",
      "FP.fr",
      "SAN.fr",
      "ADS.de",
      "DAI.de",
      "LHA.de",
      "SAP.de",
      "ALV.de",
      "GLEN.uk",
      "BNP.fr",
      "DBK.de",
      "HSBA.uk",
      "BATS.uk",
      "_ACA.FR",
      "SMI",
      "_DEUTSCHE_B",
      "_DAI.DE",
      "_E.ON",
      "_BAYER",
      "_TOTAL",
      "_INTESA_SAN",
      "_VK.FR",
      "_UNICREDITO",
      "_TELECOM_IT",
      "_SPM.IT",
      "_SAP.DE",
      "_RWE.DE",
      "_TESCO.UK",
      "_RIO.UK",
      "_SIEMENS",
      "_BMW.DE",
    ],
    comodity: [
      "CORN",
      "WHEAT",
      "NGAS",
      "WHEATF",
      "CORNF",
      "USOil",
      "UKOil",
      "GOLD",
      "SILVER",
      "CrudeOIL",
      "GASOLINE",
      "BRENT_OIL",
      "NATURAL_GAS",
      "HEATING_OIL",
      "PLATINUM",
      "PALLADIUM",
      "SOYBEAN",
      "COTTON#2",
      "SUGAR#11",
      "COFFEE_C",
      "COCOA",
      "Copper",
      "USOil",
      "UKOil",
      "NGAS",
      "CANNABIS",
    ],
    cryptocurrency: [
      "USDNIO",
      "BCHUSD",
      "BTGUSD",
      "BTCJPY",
      "BTCEUR",
      "BTCUSD",
      "XLMUSD",
      "ETHUSD",
      "DASHUSD",
      "LTCUSD",
      "ETCUSD",
      "BNBUSD",
      "CryptoMajor",
      "NEOUSD",
      "ETH",
      "MIOTAUSD",
      "XRP",
      "DOTUSD",
      "LTC_Mini",
      "XRPUSD",
      "USDNIO",

    ],
    bonds: [
      "Bund",
      "_BARCLAYS",
      "JAPAN_BOND",
      "EURO-BUND",
      "USB10YUSD-e",

    ],
    indexes: [
      "FRA40",
      "INDIA50",
      "US_TECH100",
      "DAX30",
      "US_500",
      "FTSEMIB40",
      "AEX",
      "CAC40",
      "DJ_EUR50",
      "CHINA_A50",
      "GER30",
      "NAS100",
      "USEquities",
      "SPX500",
      "CHN50",
      "EUSTX50",
      "US2000",
      "US_2000",
      "US_30",
      "NIKKEI225",
      "HSI",
      "SPI200",
      "FTSE100",
      "JPN225",
      "US30",
      "AUS200",
      "UK100",
      "HKG33",
      "ESP35",
      "SPAIN35",
      "EMBasket",
      "USDOLLAR",
      "BIOTECH",
      "JPYBasket",
      "OMX30",
      "CHN.TECH",
      "CHN.ECOMM",
      "ESPORTS",
      "DOLLAR_INDX",
    ],
  },
};

export default config;
